import React from "react";
import api from "../lib/api";
import { useSettings } from "../context/SettingsContext";
import Seo from "../components/site/Seo";
import Html from "../components/site/Html";

const stats = [
  { k: "7+", v: "Flagship products" },
  { k: "50k+", v: "Active users" },
  { k: "12+", v: "Countries served" },
  { k: "99.9%", v: "Uptime" },
];

const About = () => {
  const { settings } = useSettings();

  return (
    <div data-testid="about-page">
      <Seo
        title="About — Reptile Global"
        description="Reptile Global is a multi-product software company building flagship SaaS for finance, HR, retail and more."
        organizationSchema={settings?.organization_schema}
      />
      <section className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-3">About us</div>
            <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter text-zinc-950 leading-[0.95]">
              We're building the <span className="text-orange-500">software stack</span> for emerging markets.
            </h1>
            {settings?.about_content ? (
              <Html html={settings.about_content} className="mt-6 text-lg text-zinc-700" />
            ) : (
              <p className="mt-6 text-lg text-zinc-600 leading-relaxed">
                Reptile Global is a multi-product software company headquartered in India, serving customers across the globe.
              </p>
            )}
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
            {stats.map((s, i) => (
              <div key={i} className="bg-white border border-zinc-200 rounded-2xl p-7">
                <div className="font-display font-black text-4xl text-zinc-950">{s.k}</div>
                <div className="text-sm text-zinc-600 mt-1">{s.v}</div>
              </div>
            ))}
          </div>

          <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { title: "Our mission", body: "Build software that turns chaos into clarity for businesses everywhere." },
              { title: "Our craft", body: "Beautiful interfaces, ruthless reliability, obsession with details." },
              { title: "Our promise", body: "Real engineers, real timelines, real outcomes. No hand-waving." },
            ].map((c, i) => (
              <div key={i} className="bg-white border border-zinc-200 rounded-2xl p-8">
                <div className="font-display font-bold text-xl text-zinc-900 mb-3">{c.title}</div>
                <p className="text-zinc-600 text-sm leading-relaxed">{c.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
